import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { ApiMessageType } from "../types/api-message.type";
import { TranslateService } from "@ngx-translate/core";
import { catchError, map, Observable, of, take } from "rxjs";
@Injectable({
	providedIn: "root",
})
export class AlertNewSnakbarService {
	constructor(
		@Inject(DOCUMENT) private _document: Document,
		private router: Router,
		private translate: TranslateService
	) {}

	private getTranslation(
		key: string,
		name?: string,
		value?: number
	): Observable<string> {
		return this.translate.get(key, { name, value }).pipe(
			take(1),
			map((translatedText: string) => translatedText || key),
			catchError(() => of(key))
		);
	}

	// ========================== snack bar alert
	createSnakBar(
		statusType: ApiMessageType,
		description: string,
		title?: string,
		buttonHtml?: string,
		buttonCallback?: () => void
	): void {
		let snakBarHolderBox = this._document.querySelector(".alert-snak-bar");
		let statusClass: string = "info";
		const url = this.router.url;
		let itemSnakbar = this._document.createElement("div");

		let textSnakbar = this._document.createElement("div");
		let titleSnakbar = this._document.createElement("h4");
		let descriptionSnakbar = this._document.createElement("p");
		textSnakbar.className = "text-box";
		titleSnakbar.className = "title-alert text-sm font-weight-semibold";
		descriptionSnakbar.innerHTML = description;

		this.getTranslation(description).subscribe((text) => {
			descriptionSnakbar.innerHTML = text;
		});
		descriptionSnakbar.className =
			"description-alert text-sm font-weight-regular";
		if (title !== "") {
			titleSnakbar.innerHTML = title;

			this.getTranslation(title).subscribe((text) => {
				titleSnakbar.innerHTML = text;
			});
			textSnakbar.append(titleSnakbar);
		}
		textSnakbar.append(descriptionSnakbar);

		let itemIcon = this._document.createElement("div");
		let itemIconChildI = this._document.createElement("i");

		let itemIconCloseParent = this._document.createElement("span");
		let itemIconClose = this._document.createElement("i");
		itemIconClose.className = "fa-regular fa-close";
		itemIconCloseParent.append(itemIconClose);

		switch (statusType) {
			case ApiMessageType.Successful:
				statusClass = "success";
				itemIcon.className = "ico-img success";
				itemIconChildI.className = "ico-check-circle";
				// itemIcon.src = './assets/media/images/new-design/alert-success.svg';
				itemIcon.append(itemIconChildI);
				itemSnakbar.append(itemIcon);
				break;
			case ApiMessageType.Warning:
				statusClass = "warning";
				itemIcon.className = "ico-img warning";
				itemIconChildI.className = "ico-alert-circle";
				// itemIcon.src = './assets/media/images/new-design/alert-warning.svg';
				itemIcon.append(itemIconChildI);
				itemSnakbar.append(itemIcon);
				break;
			case ApiMessageType.Error:
				statusClass = "error";
				itemIcon.className = "ico-img error";
				itemIconChildI.className = "ico-alert-circle";
				// itemIcon.src = './assets/media/images/new-design/alert-error.svg';
				itemIcon.append(itemIconChildI);
				itemSnakbar.append(itemIcon);
				break;
			default:
				statusClass = "info";
				break;
		}

		itemSnakbar.append(textSnakbar);
		itemSnakbar.append(itemIconCloseParent);
		if (buttonHtml && buttonHtml !== "") {
			let buttonWrapper = this._document.createElement("div");
			buttonWrapper.className = "button-alert-wrapper";
			buttonWrapper.innerHTML = buttonHtml;
			let buttonElement = buttonWrapper.firstElementChild as HTMLElement;

			// Add click event (if a function is provided)
			if (buttonCallback && buttonElement) {
				buttonElement.addEventListener("click", (event) => {
					event.stopPropagation(); // Prevent other events
					itemSnakbar.remove();
					buttonCallback();
				});
			}

			itemSnakbar.append(buttonWrapper);
		}

		itemSnakbar.className = "item" + " " + statusClass;

		if (snakBarHolderBox) {
			snakBarHolderBox.prepend(itemSnakbar);
		} else {
			let holderSnakbar = this._document.createElement("div");
			holderSnakbar.prepend(itemSnakbar);
			holderSnakbar.className = "alert-snak-bar";
			this._document.body.prepend(holderSnakbar);
		}
		itemIconCloseParent.addEventListener("click", () => {
			itemSnakbar.remove();
		});
		setTimeout(() => {
			itemSnakbar.remove();
		}, 5000);
	}

	snackBarSuccess(
		text: string,
		title: string = "",
		buttonHtml: string = "",
		buttonCallback?: () => void
	): void {
		this.createSnakBar(
			ApiMessageType.Successful,
			text,
			title,
			buttonHtml,
			buttonCallback
		);
	}

	snackBarError(
		text: string,
		title: string = "",
		buttonHtml: string = "",
		buttonCallback?: () => void
	): void {
		this.createSnakBar(
			ApiMessageType.Error,
			text,
			title,
			buttonHtml,
			buttonCallback
		);
	}

	snackBarWarning(
		text: string,
		title: string = "",
		buttonHtml: string = "",
		buttonCallback?: () => void
	): void {
		this.createSnakBar(
			ApiMessageType.Warning,
			text,
			title,
			buttonHtml,
			buttonCallback
		);
	}

	snackBarInfo(
		text: string,
		title: string = "",
		buttonHtml: string = "",
		buttonCallback?: () => void
	): void {
		this.createSnakBar(
			ApiMessageType.Info,
			text,
			title,
			buttonHtml,
			buttonCallback
		);
	}
}
